import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ColumnMode } from '@swimlane/ngx-datatable';
import { AddFlightRQ, DeleteFlightRQ, FlightListModel, FlightListModelToExport, FlightService, UpdateFlightRQ } from 'app/open-api';
import { CreateFlightModalComponent } from 'app/shared/components/create-flight-modal/create-flight-modal.component';
import { FlightExpensesModalComponent } from 'app/shared/components/flight-expenses-modal/flight-expenses-modal.component';
import { NgxSpinnerService } from 'ngx-spinner';
import { AuthService } from '../../authentication/services/auth.service';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import Swal from 'sweetalert2';
import { FlightBillsComponent } from 'app/pages/flight-bills/flight-bills.component';
import { DatePipe, CurrencyPipe } from '@angular/common';
import { ShippingType, shippingTypes } from '../../open-api/model/shippingType';
import { NgbPopover } from "@ng-bootstrap/ng-bootstrap";
import * as XLSX from 'xlsx';
pdfMake.vfs = pdfFonts.pdfMake.vfs;

@Component({
  selector: "app-flight",
  templateUrl: "./flight.component.html",
  styleUrls: ["./flight.component.scss"],
  providers: [DatePipe, CurrencyPipe],
})
export class FlightComponent implements OnInit {
  public basicSelectedOption: number = 5;
  public flights: FlightListModel[] = [];
  public allFlights: FlightListModel[] = [];
  public ColumnMode = ColumnMode;
  @ViewChild("TABLE") table: ElementRef;
  shippingTypes: Array<ShippingType> = [];
  isAdmin = false;

  constructor(
    private flightService: FlightService,
    private _authenticationService: AuthService,
    private modalService: NgbModal,
    private spinner: NgxSpinnerService,
    private datePipe: DatePipe,
    private currencyPipe: CurrencyPipe
  ) {
    this.shippingTypes = shippingTypes;
  }

  ngOnInit(): void {
    this.checkIsAdmin();
    this.FetchModels();
  }

  FetchModels() {
    this.spinner.show();
    this.flightService.apiFlightListGet().subscribe((response) => {
      this.flights = response.list;
      this.allFlights = response.list;
      this.spinner.hide();
    });
  }

  FilterUpdate(event) {
    if (event && event !== "") {
      this.flights = this.allFlights.filter(
        (x) => x.code.toLowerCase().indexOf(event.toLowerCase()) > -1
      );
    } else {
      this.flights = this.allFlights;
    }
  }

  OpenBillsModal(flightId?: number) {
    const modalRef = this.modalService.open(FlightBillsComponent, {
      windowClass: "modal",
      size: "lg",
    });
    modalRef.componentInstance.flightId = flightId;
    modalRef.result.then((result) => {
      // this.FetchModels();
    });
  }

  ShowDelete(flightId: number) {
    return this.allFlights.find((x) => x.id === flightId)?.isActive;
  }

  OpenCreateModal(flightId?: number) {
    const modalRef = this.modalService.open(CreateFlightModalComponent, {
      windowClass: "modal",
    });
    if (flightId) {
      const flight = this.allFlights.find((x) => x.id === flightId);
      modalRef.componentInstance.flight = flight;
    }

    modalRef.result.then((result) => {
      if (result && !result.id) {
        this.spinner.show();
        const params: AddFlightRQ = result;
        this.flightService.apiFlightAddPost(params).subscribe(
          (response) => {
            Swal.fire({
              title: "Vuelo Creado.",
              icon: "success",
              showConfirmButton: false,
              timer: 2000,
              position: "top-end",
            });
            this.FetchModels();
          },
          (error) => {
            Swal.fire({
              title: "Error al crear vuelo. " + error,
              icon: "error",
              showConfirmButton: false,
              timer: 2000,
              position: "top-end",
              customClass: {
                confirmButton: "btn btn-primary",
              },
            });
            this.spinner.hide();
          }
        );
      } else if (result && result.id) {
        this.spinner.show();
        const params: UpdateFlightRQ = result;
        this.flightService.apiFlightUpdatePost(params).subscribe(
          (response) => {
            Swal.fire({
              title: "Vuelo Actualizado.",
              icon: "success",
              showConfirmButton: false,
              timer: 2000,
              position: "top-end",
            });
            this.FetchModels();
          },
          (error) => {
            Swal.fire({
              title: "Error al actualizar el vuelo. " + error,
              icon: "error",
              showConfirmButton: false,
              timer: 2000,
              position: "top-end",
              customClass: {
                confirmButton: "btn btn-primary",
              },
            });
            this.spinner.hide();
          }
        );
      }
    });
  }

  OpenExpensesModal(flightId: number) {
    const modalRef = this.modalService.open(FlightExpensesModalComponent, {
      windowClass: "modal",
      size: "lg",
    });
    modalRef.componentInstance.flight = this.flights.find(
      (x) => x.id === flightId
    );
    modalRef.result.then((result) => {
      this.FetchModels();
    });
  }

  ExportTOExcel() {
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(
      this.table.nativeElement
    );
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

    /* save to file */
    XLSX.writeFile(wb, "SheetJS.xlsx");
  }

  exportList(): FlightListModelToExport[]{
    let exportflights: FlightListModelToExport[] = [];
    if (this.flights)
      this.flights.forEach((row) => {
        let now: FlightListModelToExport = this.GetFlightToExport(row);
        exportflights.push(now);
      });  
      return exportflights;  
  }

  GetFlightToExport(row: FlightListModel) {   

    let ret: FlightListModelToExport = {
      CODIGO: row.code,
      CODIGO_ENVIO: row.shippingCode,
      DESCRIPCION_ENVIO: row.shippingDescription,
      COSTO_TOTAL: this.currencyPipe.transform(row.totalCost),
      FECHA_ENVIO: this.datePipe.transform(row.shippingCreateAt, "MMM/dd/yyyy"),
      FECHA_VUELO: this.datePipe.transform(row.flightDate, "MMM/dd/yyyy"),
      TIPO_ENVIO: this.shippingTypes.find(b => b.id === row.shippingType).name,
      ACTIVO : row.isActive     
    };
    return ret;
  }

  export(){
    const swal = Swal.fire({
      title: "Escoja la opción de exportar datos.",      
      icon: "warning",
      showCancelButton: true,
      showCloseButton: true,
      confirmButtonText: "Excel",
      cancelButtonText: "PDF",
      customClass: {
        confirmButton: "btn btn-primary",
        cancelButton: "btn btn-danger",
      },
    }).then((result) => {
      console.log(result)
      if (result.isConfirmed) {
        this.exportexcel();
      }
      else if (result.isDismissed && result.dismiss == Swal.DismissReason.cancel){
        this.generatePDF();
      }
    })
  }

  exportexcel(): void
  {
    /* pass here the data source */
    let exportobj: any = this.exportList();
    console.log(exportobj)
    const ws: XLSX.WorkSheet =XLSX.utils.json_to_sheet(exportobj);
 
    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    let newDate:  Date = new Date();
    const fecha = this.datePipe.transform(newDate, "MMM/dd/yyyy");
    
    let fileName: any = `vuelos_${fecha}.xlsx`;
 
    /* save to file */  
    XLSX.writeFile(wb, fileName);
 
  }

  generatePDF() {
    this.spinner.show();
    const contenido: string[][] = [];
    contenido.push([
      "#",
      "CODIGO",
      "TIPO ENVIO",
      "CODIGO ENVIO",
      "FECHA VUELO",
      "GASTOS",
      "ESTADO",
    ]);
    console.log(this.flights);
    this.flights.forEach((b, index) => {
      contenido.push([
        (index + 1).toString(),
        b.code,
        this.shippingTypes.find(row => row.id === b.shippingType).name,
        b.shippingCode,
        this.datePipe.transform(b.shippingCreateAt, "MMM/dd/yyyy"),
        this.currencyPipe.transform(b.totalCost),
        b.isActive ? "Abierto" : "Cerrado",
      ]);
    });
    const totalColumn: any[] = [];

    const documentDefinition = {
      pageOrientation: "landscape",
      pageSize: "LETTER",
      content: [
        {
          columns: [
            { text: "Reporte de vuelos: ", style: ["title"], margin: [0, 10] },
          ],
        },
        {
          text: "Fecha: " + this.datePipe.transform(new Date(), "MMM/dd/yyyy"),
          style: ["subtitle"],
          margin: [0, 0],
        },
        {
          layout: "lightHorizontalLines",
          table: {
            headerRows: 1,
            widths: ["auto", "auto", "auto", "auto", "auto", "auto", "auto"],
            body: contenido,
          },
        },
      ],
      styles: {
        title: {
          fontSize: 22,
          bold: true,
          alignment: "left",
        },
        title2: {
          fontSize: 12,
          bold: true,
          alignment: "right",
        },
        subtitle: {
          fontSize: 14,
          alignment: "left",
        },
        footer: {
          fontSize: 8,
          alignment: "right",
        },
      },
    };
    pdfMake.createPdf(documentDefinition).open();
    this.spinner.hide();
  }

  checkIsAdmin(){    
    this.isAdmin = this._authenticationService.isAdministrator;
  }

  checkIfFlightHasBills(flightId: number){
    return this.allFlights.find((x) => x.id === flightId)?.hasBills;
  }

  Delete(flightId: number) {
    if(this.checkIfFlightHasBills(flightId)){
      if(this.isAdmin){
        const swal = Swal.fire({
          title: "EL vuelo tiene facturas asociadas y solo puede ser eliminado por un Administrador. ¿Está seguro que desea eliminar el vuelo?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Eliminar",
          cancelButtonText: "Cancelar",
          customClass: {
            confirmButton: "btn btn-danger",
            cancelButton: "btn btn-primary",
          },
        }).then((result) => {
          if (result.isConfirmed) {
            const param: DeleteFlightRQ = {
              id: flightId,
              isAdmin: this.isAdmin
            };
            this.flightService.apiFlightDeletePost(param).subscribe(
              (response) => {
                Swal.fire({
                  title: "Vuelo Eliminado",
                  icon: "success",
                  showConfirmButton: false,
                  timer: 2000,
                  position: "top-end",
                }); 

                setTimeout(() => {
                  this.FetchModels();
                }, 2000);
                //this.FetchModels();               
              },
              (error) => {
                Swal.fire({
                  title: "Error al eliminar el vuelo. " + error,
                  icon: "error",
                  showConfirmButton: false,
                  timer: 2000,
                  position: "top-end",
                  customClass: {
                    confirmButton: "btn btn-primary",
                  },
                });
              }
            );
          }
        });
      }
      else {
        Swal.fire({
          title: "El vuelo tiene facturas asociadas y solo puede ser eliminado por un Administrador.",
          icon: "error",
          showConfirmButton: false,
          timer: 2000,
          position: "top-end",
          customClass: {
            confirmButton: "btn btn-primary",
          },
        });
      }
    }
    else {
      const swal = Swal.fire({
        title: "¿Está seguro que desea eliminar el vuelo?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Eliminar",
        cancelButtonText: "Cancelar",
        customClass: {
          confirmButton: "btn btn-danger",
          cancelButton: "btn btn-primary",
        },
      }).then((result) => {
        if (result.isConfirmed) {
          const param: DeleteFlightRQ = {
            id: flightId,
            isAdmin: this.isAdmin
          };
          this.flightService.apiFlightDeletePost(param).subscribe(
            (response) => {
              Swal.fire({
                title: "Vuelo Eliminado",
                icon: "success",
                showConfirmButton: false,
                timer: 2000,
                position: "top-end",
              });

              setTimeout(() => {
                this.FetchModels();
              }, 2000);
              
            },
            (error) => {
              Swal.fire({
                title: "Error al eliminar el vuelo. " + error,
                icon: "error",
                showConfirmButton: false,
                timer: 2000,
                position: "top-end",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
              });
            }
          );
        }
      });
    }
   
  }
}
